/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-console */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState, useRef } from 'react';
import { get } from 'lodash';
import { Box, Modal, Grid, Tooltip, IconButton, SvgIcon, alpha, styled } from '@mui/material';
import { Rnd } from 'react-rnd';
import CloseIcon from '@mui/icons-material/Close';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import { useTranslation } from 'react-i18next';
import UIGrid from '../uigrid';
import RoLatest from './ro-latest';
import RoTables from './ro-tables';
import StageTable from './stage-tables';
import ElementTable from './element-tables';
import './explorer.scss';
import CLROPage from './clro-page';
import { sortingRoData } from '../../shared/constantVariable';

const Explorer = (props) => {
  const { explorerOption, handleCloseOption, report_invoice } = props;
  const storageData = JSON.parse(localStorage.getItem('ro_ouput_data')) || {};
  const unitData = JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const roDict = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', {});
  const [unit_set_dict] = useState(unitData);
  const { t } = useTranslation();
  const [parentNum, setParentNum] = useState(0);
  const [levelNum, setLevelNum] = useState(0);
  const [showComponent, setShowComponent] = useState('RO_1');
  const [expanded, setExpanded] = React.useState(['1']);
  const [isLoading, setIsLoading] = useState(false);
  const [sortedRoData, setSortedRoData] = useState([]);
  const [sortinglocalStorageRoData, setSortinglocalStorageRoData] = useState([]);
  const elementCircle = useRef([]);
  const explorerElement = useRef([]);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const getData = () => {
    let val = [];
    // sorting RO data based on sequence in unitop. start
    if (sortedRoData.length === 0) {
      val = sortingRoData();
      setSortinglocalStorageRoData(val.localStorageId);
      setSortedRoData(val.sortingVal);
      val = val.sortingVal;
    } else {
      val = sortedRoData;
    }
    // sorting RO data based on sequence in unitop. End
    // if remove sorting uncomment below line and comment 'if (sortedRoData.length === 0) {' this line
    // const val = Object.keys(storageData);

    const newArry = val.map((key) => {
      // Checking all ro related unitsops -> if present then only sending its output_user data
      if (storageData[key].unit_type && ['RO', 'RO_HP', 'RO_ERD', 'RO_PW', 'RO_TC', 'CLRO'].indexOf(storageData[key].unit_type) >= 0) {
        if (storageData[key].output_user && storageData[key].output_user.name) {
          return storageData[key].output_user;
        }
        return undefined;
      }
    });
    const storageArry = newArry.filter(m => m !== undefined);
    return storageArry;
  };
  const stagesList = getData(storageData);
  const [stageData, setStageData] = useState({});
  const feild_data = [
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' },
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' },
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' },
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' },
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' },
    { 'name': '', 'recovery': ' ', 'temp': ' ', 'feed_press': ' ', 'avg_flux': '', 'max_flux': '' }
  ];
  const [systemData, setSystemData] = useState(feild_data);
  const [roDictData, setRoDictData] = useState(roDict[Object.keys(roDict)[0]]);
  const getFloatVal = (val, fixedVal) => {
    if (val !== '' && !Number.isNaN(Number(val))) {
      return Number(val).toFixed(fixedVal);
    }
    return val || '-';
  };
  const systemdatavalues = (d) => {
    let sys_info = [];
    d.forEach((v) => {
      const obj = {};
      obj.name = v.name;
      obj.recovery = getFloatVal(v.recovery, 1);
      obj.temp = getFloatVal(v.temp, 1);
      obj.feed_press = getFloatVal(v.feed_press, 2);
      obj.avg_flux = (v.avg_flux && unit_set_dict.Flux === 'm/s') ? Number.parseFloat(v.avg_flux).toExponential(2) : getFloatVal(v.avg_flux, 2);
      obj.max_flux = (v.max_flux && unit_set_dict.Flux === 'm/s') ? Number.parseFloat(v.max_flux).toExponential(2) : getFloatVal(v.max_flux, 2);
      sys_info.push(obj);
    });
    // if remove sorting comment below line 120 to 135
    // sorting RO data based on sequence in unitop. End
    const data = [];
    sortedRoData.map((ele) => {
      sys_info.map((e) => {
        if (ele === e.name) {
          data.push(e);
        } else if (e.name === 'System') {
          data.splice(0, 0, e);
        }
      });
    });
    const seen = new Set();
    sys_info = data.filter(el => {
      const duplicate = seen.has(el.name);
      seen.add(el.name);
      return !duplicate;
    });
    // sorting RO data based on sequence in unitop. End
    if (sys_info.length < 7) {
      feild_data.slice(sys_info.length - 6).forEach((d) => {
        sys_info.push(d);
      });
    }
    setSystemData(sys_info);
  };
  useEffect(() => {
    if (stagesList.length > 0) {
      setShowComponent(stagesList[0].name);
      setStageData(stagesList[0]);
    }
    setRoDictData(roDict[sortinglocalStorageRoData[0]]);
  }, []);
  useEffect(() => {
    const loader = setInterval(() => {
      setIsLoading(false);
    }, 1000);
    let flagStageList = true;
    for (let i = 0; i < stagesList.length; i += 1) {
      if (flagStageList && stagesList[i].system_data) {
        flagStageList = false;
        systemdatavalues(stagesList[i].system_data);
      }
    }
    if (flagStageList) {
      setSystemData([]);
    }
    return () => clearInterval(loader);
  }, [isLoading]);

  function MinusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
      </SvgIcon>
    );
  }

  function PlusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
      </SvgIcon>
    );
  }

  function CloseSquare(props) {
    return (
      <SvgIcon
        className="close"
        fontSize="inherit"
        style={{ width: 14, height: 14 }}
        {...props}
      >
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
      </SvgIcon>
    );
  }

  const StyledTreeItem = styled((props) => (
    <TreeItem {...props} />
  ))(({ theme }) => ({
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.3,
      },
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  }));

  const streamData = (ctype, item, parent, child) => {
    setTimeout(() => {
      const allExpendedNode = [];
      let parentElement = document.querySelector('.Mui-selected');
      while (parentElement) {
        parentElement = parentElement.closest('li');
        let expendNode = parentElement.id.split('-');
        expendNode = expendNode[expendNode.length - 1];
        allExpendedNode.push(expendNode);
        parentElement = parentElement.parentNode.closest('li');
      }
      allExpendedNode.sort((a, b) => a < b ? -1 : 1);
      setTimeout(() => {
        if (ctype === 'Element' || ctype === 'Stages') {
          elementCircle.current.forEach((ele) => {
            ele.classList.remove('activeNode');
          });
          explorerElement.current.forEach((ele) => {
            ele.classList.remove('activeNode-text');
          });
          document.querySelectorAll('.element-table tbody tr').forEach((ele) => {
            ele.classList.remove('active');
          });
          if (ctype !== 'Stages') // added by chandrashekhar when user click on stage element is not higglited
            setTimeout(() => {
              elementCircle.current[child].classList.add('activeNode');
              explorerElement.current[child].classList.add('activeNode-text');
              document.querySelectorAll('.element-table [class$="table_01"] tbody tr')[child].classList.add('active');
            }, 100);
        }
      }, 100);
      setExpanded(allExpendedNode);
    }, 1000);
    if (item && item.name && (ctype !== 'Element' || ctype !== 'Stages')) {
      // let itemData = item.name.split('_');
      // itemData = itemData[itemData.length - 1];
      // setRoDictData(roDict[`roPump_${itemData}`]);
      let allData = '';
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (localStorage.getItem(key) === item.name) {
          allData = key;
        }
      }
      setRoDictData(roDict[allData]);
    }
    item.unique_id = `update_${(Math.random() + 1).toString(36).substring(7)}`;
    setParentNum(parent);
    setLevelNum(child);
    setShowComponent(ctype);
    setStageData(item);
    setIsLoading(true);
    setIsInitialRender(true);
  };
  let nodeItemIndex = 0;
  const nodeId = () => {
    nodeItemIndex += 1;
    return nodeItemIndex.toString();
  };
  const [roColData1] = useState([
    { tag: 'name', hdata: ' ', maxWidth: 50, minWidth: 20, disabled: true },
    { tag: 'temp', hdata: `${t('Temperature')}, ${unitData.Temperature}`, minWidth: 20, disabled: true },
    { tag: 'recovery', hdata: `${t('Recovery')}, %`, disabled: true },
    { tag: 'feed_press', hdata: `${t('Feed Pressure')}, ${unitData.Pressure}`, disabled: true },
    { tag: 'avg_flux', hdata: `${t('Permeate Flux')}, ${unitData.Flux}`, disabled: true },
    { tag: 'max_flux', hdata: ' ', disabled: true }
  ]);
  const headerData = [[
    { hdata: '', colspan: 0 },
    { hdata: `${t('Temperature')}, ${unitData.Temperature}`, colspan: 0 },
    { hdata: `${t('Recovery')}, %`, colspan: 0 },
    { hdata: `${t('Feed Pressure')}, ${unitData.Pressure}`, colspan: 0 },
    { hdata: `${t('Permeate Flux')}, ${unitData.Flux}`, colspan: 2 }
  ], [
    { hdata: '', colspan: 4 },
    { hdata: `${t('Average')}`, colspan: 0 },
    { hdata: `${t('Element Max')}`, colspan: 0 }
  ]];

  return (
    <Modal
      hideBackdrop
      open={explorerOption}
      onClose={handleCloseOption}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="explorer-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '85%',
            x: ((window.innerWidth / 2) - ((85 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((70 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='47%'
          cancel=".explorer-header-text, .MuiTreeItem-label, .explorer-element, #grid, .box-border, .no_drag"
          className='explorer-box explorer-width'>
          <Grid container className='explorer-grid-container'>
            <Grid item xs={12} className='explorer-header-grid'>
              <div className='explorer-header-text rufusBld no_drag S_heading'>{t('Explorer')}</div>
              <div className='explorer-close-icon no_drag'>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="save"
                    onClick={handleCloseOption}
                    size="large"
                    className="close-icon"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='explorer-content-grid explorer-height'>
              <div className="exp-card-cont card-container">
                <Grid container>
                  {systemData.length > 0 && (
                    <Grid item xs={12} className='system_details'>
                      <UIGrid
                        data={systemData}
                        headerData={headerData}
                        properties={roColData1}
                        tableClassName='system_data'
                        checkCustomHeader='true'
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                    <TreeView
                      aria-label="customized"
                      expanded={expanded}
                      defaultSelected={['1']}
                      defaultCollapseIcon={<MinusSquare />}
                      defaultExpandIcon={<PlusSquare />}
                      defaultEndIcon={<CloseSquare />}
                      sx={{ minHeight: '490px', flexGrow: 1, maxWidth: 500, overflowY: 'auto', overflowX: 'hidden', fontSize: '12px', border: '1px solid #00AEC74D', borderRadius: '5px' }}
                      className="treeList"
                    >
                      {stagesList.length > 0 && stagesList.map((list) => (
                        <StyledTreeItem key={`aa${Math.random().toString(36).slice(2, 7)}`} nodeId={nodeId()} label={list.name} onClick={() => streamData(list.name, list, 0, 0)}>
                          {list.stage.length > 0 && list.stage.map((item, i) => (
                            <StyledTreeItem key={`bb${Math.random().toString(36).slice(2, 7)}`} nodeId={nodeId()} label={`Stage - ${i + 1}`} onClick={() => streamData('Stages', item, i, 0)}>
                              <div className="explorer-element">
                                <ul>
                                  {item.pres_vessels[0].module.map((elem, j) => (
                                    <li key={`cc${Math.random().toString(36).slice(2, 7)}`} style={{ position: 'relative' }}>
                                      <span ref={el => { elementCircle.current[j] = el; }} className="element-circle"
                                        onClick={() => streamData('Element', item, i, j)} />
                                      <span ref={el => { explorerElement.current[j] = el; }} className="explorer-element-text" key={j + 1} nodeId={nodeId()}
                                        onClick={() => streamData('Element', item, i, j)}>{`Element - ${j + 1}`}</span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </StyledTreeItem>
                          ))}
                        </StyledTreeItem>
                      ))}
                    </TreeView>
                  </Grid>
                  {
                    stagesList.length > 0 &&
                    (
                      <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                        <div style={{ display: isLoading ? '' : 'none' }}>
                          <div className="pleaseWaitText" style={{ color: '#2C2C2C' }}>{t('Loading Please wait...')}</div></div>
                        <div style={{ display: isLoading ? 'none' : '' }}>
                          <div className='element-table'>
                            {(() => {
                              if (showComponent === 'Stages') {
                                return (
                                  <StageTable parentNum={parentNum} levelNum={levelNum} stageData={stageData} unit_set_dict={unit_set_dict} handleCloseOption={handleCloseOption} translateObject={t} />
                                );
                              }
                              if (showComponent === 'Element') {
                                return (
                                  <ElementTable parentNum={parentNum} levelNum={levelNum} stageData={stageData} unit_set_dict={unit_set_dict} handleCloseOption={handleCloseOption} translateObject={t} />
                                );
                              }
                              if (stageData.unitop === 'CLRO') {
                                return (
                                  <CLROPage isInitialRender={isInitialRender} setIsInitialRender={setIsInitialRender} stageData={stageData} clroOverView={report_invoice.report_dict.clro_overview} report_invoice={report_invoice.report_dict.clro_elem_summary} stagesList={stagesList} unit_set_dict={unit_set_dict} handleCloseOption={handleCloseOption} roDictData={roDictData} translateObject={t} />
                                );
                              }
                              if (showComponent !== 'RO_1') {
                                return (
                                  <RoTables parentNum={parentNum} levelNum={levelNum} stageData={stageData} unit_set_dict={unit_set_dict} handleCloseOption={handleCloseOption} roDictData={roDictData} translateObject={t} />
                                );
                              }
                              if (showComponent === 'RO_1') {
                                return (
                                  <RoLatest stagesList={stagesList} unit_set_dict={unit_set_dict} handleCloseOption={handleCloseOption} roDictData={roDictData} translateObject={t} />
                                );
                              }
                            })()}
                          </div>
                        </div>
                      </Grid>
                    )
                  }
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};

export default Explorer;
